import React, { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogTitle, DialogContent, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import { IconButton } from "@mui/material";
import {
  Edit as EditIcon,
  Check as CheckIcon,
  Close as CloseIcon,

} from "@mui/icons-material";
import "../App.css";
import configs from "../Constants";

const PromotionPage = () => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [contentPopup, setContentPopup] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [availableImages, setAvailableImages] = useState([]);
  const [caption, setCaption] = useState("");
  const [sub_caption, setSubCaption] = useState("");
  const [url, setUrl] = useState("");
  const [id, setId] = useState("");
  const [useAt, setUseAt] = useState("");
  let merchantData = localStorage.getItem("merchantData")
    ? JSON.parse(localStorage.getItem("merchantData"))
    : null;
  const merchCode = merchantData ? merchantData.merchantCode : "xyz";

  let baseURL = configs.baseURL;
  let cmsUrl = `${configs.cmsUrl}`;
  let staticURL = configs.staticSer;
  let userToken = localStorage.getItem("token") || "";

  useEffect(() => {
    const getImg = async () => {
      try {
        const res = await axios.get(`${cmsUrl}/api/user/media`, {
          headers: { Authorization: `Bearer ${userToken}` },
        });

        if (res.data && res.data.mediaData) {
          // Filter out only the files that contain .img, .jpg, or .png
          const extractedImages = res.data.mediaData
            .filter((item) => {
              const fileName = item.original_file_name.toLowerCase();
              return (
                fileName.includes(".img") ||
                fileName.includes(".jpg") ||
                fileName.includes(".jpeg") ||
                fileName.includes(".png")
              );
            })
            .map((item) => item.original_file_name);

          setAvailableImages(extractedImages);
        }
      } catch (err) {
        console.error("Error fetching media:", err);
      }
    };

    getImg();
  }, []);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await axios.get(
          `${baseURL}/api/promos?merchantCode=${merchCode}`
        );

        if (res.data.length > 0) {
          // Limit to only the number of images received (max 5)
          const updatedImages = res.data.map((item) => ({
            id: item.id || "",
            url: item.url || "",
            useAt: item.useAt || "",
            caption: item.caption || "",
            sub_caption : item.sub_caption || ""
          }));

          setSelectedImages(updatedImages);
        } else {
          setSelectedImages([]); // If no images, keep it empty
        }
      } catch (err) {
        console.log("Error fetching selected images:", err);
      }
    };

    fetchImages();
  }, []);

  const handleSelectImage = (id) => {
    setCurrentId(id);
    setOpenPopup(true);
  };

  const handleAddPromotion = () => {
    setCurrentId(null); // Set null to indicate adding a new promotion
    setOpenPopup(true);
  };

  const handleEditPromtionContent = (imgData) => {
    setCurrentId(imgData.id);
    setUrl(imgData.url);
    setUseAt(imgData.useAt);
    setCaption(imgData.caption);
    setSubCaption(imgData.sub_caption);
    setContentPopup(true);
  }

  const uploadFile = async (file, promoId, useAtType) => {
    if (!file) return;
    
    let fileName = "promo_" + new Date().getTime() + file.name.replace(/\s+/g, "");
    var formData = new FormData();
    formData.append("uploader", file, fileName);
    let postQueriesUrl = baseURL + "/api/upload/PROMOTIONS";
    
    try {
      const res = await axios.post(postQueriesUrl, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      let imageUrl = `${configs.staticSer}/PROMOTIONS/${fileName}`;
      
      if (!promoId) {
        const response = await axios.post(
          `${baseURL}/api/promos`,
          { url: imageUrl, userId: merchCode, useAt: useAtType, caption: "", sub_caption: "" },
          { headers: { Authorization: `Bearer ${userToken}` } }
        );
        setSelectedImages(prev => [...prev, { id: response.data.id, url: imageUrl, useAt: useAtType, caption: "", sub_caption: "" }]);
      } else {
        await axios.put(
          `${baseURL}/api/promos/${promoId}`,
          { url: imageUrl, userId: merchCode, useAt: useAtType, caption: "", sub_caption: "" },
          { headers: { Authorization: `Bearer ${userToken}` } }
        );
        setSelectedImages(prev => {
          const newImages = [...prev];
          const index = newImages.findIndex(img => img.id === promoId);
          if (index !== -1) {
            newImages[index] = { ...newImages[index], url: imageUrl };
          }
          return newImages;
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleDrop = (e, promoId, useAtType) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      uploadFile(e.dataTransfer.files[0], promoId, useAtType);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileInput = (e, promoId, useAtType) => {
    if (e.target.files && e.target.files[0]) {
      uploadFile(e.target.files[0], promoId, useAtType);
    }
  };

  const handleImageClick = async (image) => {
    console.log(useAt);

    let imageUrl = image || url;
    if(imageUrl && imageUrl.indexOf('http') == -1){
    imageUrl =staticURL.indexOf('reports') == -1 ?`${staticURL}/uploads/${imageUrl}`:`${staticURL}/users-media/${merchantData.userId}/${imageUrl}`;
    }
    if (!currentId) {
      // Create a new promotion
      try {
        const response = await axios.post(
          `${baseURL}/api/promos`,
          { url: imageUrl, userId: merchCode, useAt:useAt,caption,sub_caption },
          { headers: { Authorization: `Bearer ${userToken}` } }
        );
        console.log("New promotion created:", response.data);

        setSelectedImages([
          ...selectedImages,
          { id: response.data.id, url: imageUrl, useAt: useAt },
        ]);
      } catch (err) {
        console.error("Error creating new promotion:", err);
      }
    } else {
      // Update existing promotion
      const existingImageIndex = selectedImages.findIndex(
        (img) => img.id === (currentId)
      );
      const updatedImages = [...selectedImages];

      if (existingImageIndex !== -1) {
        updatedImages[existingImageIndex] = {
          ...updatedImages[existingImageIndex],
          url: imageUrl,
          useAt: useAt,
          caption,sub_caption
        };

        try {
          await axios.put(
            `${baseURL}/api/promos/${(currentId)}`,
            { url:imageUrl, userId: merchCode ,useAt:useAt,caption,sub_caption },
            { headers: { Authorization: `Bearer ${userToken}` } }
          );
          console.log("Image updated successfully");

        } catch (err) {
          console.error("Error updating selected image:", err);
        }
      }
      setSelectedImages(updatedImages);
    }
    setContentPopup(false);
    setOpenPopup(false);
  };

  console.log("available Images",caption);

  return (
    <div className="promotion-container">
      <div className="header">
        <div>
          <h4>Promotion</h4>
        </div>
        { (
          <button className="add-promotion-button" onClick={handleAddPromotion}>
            + Add Promotion
          </button>
        )}
      </div>

      <div className="pro-imag-cnt">
        <h5 style={{ marginTop: "20px", marginBottom: "15px" }}>Top Slider Horizontal (Max 3, 1:3 ratio)</h5>
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "30px" }}>
          {[0, 1, 2].map(i => {
            const slot = selectedImages.filter(img => img.useAt === "ONLINE_BANNER")[i] || { id: null, useAt: "ONLINE_BANNER" };
            return (
              <div 
                key={`h_${i}`}
                onDrop={(e) => handleDrop(e, slot.id, "ONLINE_BANNER")}
                onDragOver={handleDragOver}
                onClick={() => document.getElementById(`fileInputH_${i}`).click()}
                style={{
                  width: "300px", height: "100px", border: "2px dashed #ccc", borderRadius: "8px",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  cursor: "pointer", position: "relative",
                  backgroundImage: slot.url ? `url(${slot.url})` : "none",
                  backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center"
                }}
              >
                {!slot.url && <span style={{ color: "#888" }}>Drag & Drop Upload</span>}
                <input 
                  type="file" id={`fileInputH_${i}`} style={{ display: "none" }} 
                  onChange={(e) => handleFileInput(e, slot.id, "ONLINE_BANNER")} accept="image/*"
                />
              </div>
            );
          })}
        </div>

        <h5 style={{ marginBottom: "15px" }}>Vertical Promotions (Max 2, 16:9 portrait)</h5>
        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", marginBottom: "40px" }}>
          {[0, 1].map(i => {
            const slot = selectedImages.filter(img => img.useAt === "ONLINE_SPLASH")[i] || { id: null, useAt: "ONLINE_SPLASH" };
            return (
              <div 
                key={`v_${i}`}
                onDrop={(e) => handleDrop(e, slot.id, "ONLINE_SPLASH")}
                onDragOver={handleDragOver}
                onClick={() => document.getElementById(`fileInputV_${i}`).click()}
                style={{
                  width: "150px", height: "266px", border: "2px dashed #ccc", borderRadius: "8px",
                  display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center",
                  cursor: "pointer", position: "relative",
                  backgroundImage: slot.url ? `url(${slot.url})` : "none",
                  backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center"
                }}
              >
                {!slot.url && <span style={{ color: "#888", padding: "10px" }}>Drag & Drop Upload</span>}
                <input 
                  type="file" id={`fileInputV_${i}`} style={{ display: "none" }} 
                  onChange={(e) => handleFileInput(e, slot.id, "ONLINE_SPLASH")} accept="image/*"
                />
              </div>
            );
          })}
        </div>

        <h5 style={{ borderTop: "1px solid #eee", paddingTop: "20px" }}>Other Promotions</h5>
        <div className="promotion-grid">
          {selectedImages.filter(img => img.useAt !== "ONLINE_BANNER" && img.useAt !== "ONLINE_SPLASH").map((imageData, index) => (
            <div key={index} className="promotion-item">
              <img
                src={imageData.url || "https://via.placeholder.com/150"}
                alt={`Image ${index + 1}`}
                className="promotion-image"
              />
 <span style={{width:"50px", float:"right"}}> <IconButton
                          onClick={() => handleEditPromtionContent(imageData)}
                          aria-label="edit"
                          color="primary"
                        >
                          <EditIcon />
                        </IconButton></span>
              <span>To Be Used At</span>
              <label style={{fontWeight:"bold",marginBottom:"10px"}}>{imageData.useAt || "Not Assigned"}</label>

              <span>Caption</span>
              <label style={{fontWeight:"bold",marginBottom:"10px"}}>{imageData.caption || "No Caption"}</label>

               <span>Second Caption</span>
              <label style={{fontWeight:"bold",marginBottom:"10px"}}>{imageData.sub_caption  || "No Second Caption"}</label>
              <button
                className="promotion-button"
                onClick={() => handleSelectImage(imageData.id)}
              >
                Change Image
              </button>
              
            </div>
          ))}
        </div>
      </div>

      {/* Image Selection Popup */}
      <Dialog open={openPopup} onClose={() => setOpenPopup(false)} style={{maxWidth:"650px!important"}}>
        <DialogTitle>Select an Image 
        <div style={{fontSize:".8em"}}>Note: Images can be uploaded in Signage portal under library.</div>
        </DialogTitle>
        <DialogContent>
          <div className="image-selection-grid">
            {availableImages.length > 0 ? (
              availableImages.map((image, index) => (
                <img
                  key={index}
                  src={staticURL.indexOf('reports') == -1 ?`${staticURL}/uploads/${image}`:`${staticURL}/users-media/${merchantData.userId}/${image}`}
                  alt=""
                  className="image-option"
                  onClick={() => handleImageClick(image)}
                  style={{
                    width: "160px",
                    height: "auto",
                    cursor: "pointer",
                    margin: "5px",
                  }}
                />

              ))
            ) : (
              <p>No images available</p>
            )}
          </div>
        </DialogContent>
      </Dialog>

            <Dialog open={contentPopup} onClose={() => setContentPopup(false)} >
        <DialogTitle>Update Details
      
        </DialogTitle>
        <DialogContent>
            <div style={{margin:"10px"}}>
              <span style={{fontWeight:"bold",marginRight:"10px"}}>To be use for:</span>
              <select
                  id="use-at-opt"
                  value={useAt}
                  selected={useAt}
                  className="select_input"
                  style={{width:"100%", marginTop:"10px",padding:"10px", height:"50px"}}
                  onChange={(e) => {
                    const selectedUse = e.target.value;
                   setUseAt(selectedUse);
                  }}
                >
                  <option  value="ONLINE_BANNER">[ONLINE ORDER APP] TOP BANNER (landscape 1:3 ratio)</option>
                  <option  value="ONLINE_SPLASH">[ONLINE ORDER APP] START PROMO IMAGES  (MAX 3, Portrait 16:9 ratio)</option>
                   <option value="SOK_SPLASH">[SELF ORDER KIOSK] START PROMO IMAGES  (MAX 3, Portrait 16:9 ratio)</option>
                   <option  value="TTO_SPLASH">[TABLE ORDER TAB] START PROMO IMAGES  (Portrait 9:16 ratio)</option>
                  
                </select>

                <TextField
                          fullWidth
                          label="Caption"
                          defaultValue=""
                          onChange={(e)=> setCaption(e.target.value)}
                          name="caption"
                          value={caption}
                          size="small"
                          style={{marginTop:"10px"}}
                        />
               
                  <TextField
                          fullWidth
                          label="Second Caption"
                          defaultValue=""
                          onChange={(e)=> setSubCaption(e.target.value)}
                          name="sub_caption"
                          value={sub_caption}
                                style={{marginTop:"10px"}}
                           size="small"
                        />

                </div>
        </DialogContent>
          <div
                style={{
                  width: "100%",
                  alignItems: "center",
                  marginTop: "20px",
                  textAlign: "right",
                  padding:"20px"
                }}
              >
                <Button
                  variant="outlined"
                  color="error"
                  style={{ marginRight: "20px" }}
                  onClick={() => setContentPopup(false)}
                >
                  Close
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={()=>handleImageClick(url)}
                >
                  Save
                </Button>
              </div>
      </Dialog>
    </div>
  );
};

export default PromotionPage;
